import React from 'react';
import styled, { css } from 'styled-components';
import Modal from './Modal';
import StampMessage from './StampMessage';
import Button from './Button';

const ShortMessage = ({ success, wrong, message, onAccept }) => (
  <ModalStyled>
    <Container>
      <StampMessage success={success} wrong={wrong} text={message} />
      <ButtonState text='OK' tertiary onClick={onAccept} />
    </Container>
  </ModalStyled>
);


const Container = styled.div`
  padding: 20px;
  & > * {
    margin: 5px;
  }
`;

const ButtonState = styled(Button)`
  margin-top: 30px;
`;

const ModalStyled = styled(Modal)`
  max-width: 220px;
  width: 100%;
`;

export default ShortMessage;
